import React, { Fragment } from 'react';
import { Helpers } from '../../core/src/helpers';
import MSRPTooltip from '../../pdp/components-v2/price-block/components/msrp-tooltip';

import '../css/price.less';

export default ({
    price = {},
    spClassName,
    showListPrice,
    showSalePrice,
    pricePrefixText = '',
    displayDifference,
    prdClass,
}) => {
    const difference =
        displayDifference && price.regularPrice > price.salePrice ? price.regularPrice - price.salePrice : null;
    return (
        <Fragment>
            <span className="list-price">
                <MSRPTooltip productType={prdClass} className="price-prefix">
                    {price.regularPrice && <span className="price-prefix">{pricePrefixText}</span>}
                </MSRPTooltip>
                {showListPrice && <span className="strike-price">{Helpers.formatCurrency(price.regularPrice)}</span>}
                {difference && <span className="price-difference">Save {Helpers.formatCurrency(difference)}</span>}
            </span>
            {showSalePrice && (
                <span className={`${spClassName}${!showListPrice ? ' non-sale' : ''}`}>
                    {Helpers.formatCurrency(price.salePrice)}
                </span>
            )}
        </Fragment>
    );
};
